import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import MoreInfoIcon from '../../../components/Icons/MoreInfoIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableStarRattingFormatter from '../../../components/Table/TableAccessories/TableStarRattingFormatter';
import TableUsernameFormatter from '../../../components/Table/TableAccessories/TableUsernameFormater';
import {
  DRIVER_INFORMATION,
  USER_MANAGEMENT,
} from '../../../routes/routeConstants';
import DriverInfoStats from './DriverInfoStats';

const DriverInformation = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const { companyId, companyName } = useParams();
  const { pathname } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    setPathArr(() => [
      {
        name: `User Management`,
        link: `/${USER_MANAGEMENT}`,
      },
      {
        name: `${companyName} - Driver List`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver Information'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />

        <Container>
          <DriverInfoStats />

          <Table
            // border
            tableTitle='DRIVER LIST'
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search Driver Name',
            }}
            tableHeader={{
              'Start Date': 'startDate',
              'Driver Name': 'firstName',
              Gender: 'gender',
              'Employment Type': 'employmentType',
              'Average Rating': 'averageRating',
              'Home Address': 'address',
              Status: 'status',
            }}
            // tableDataSourceUrl={`ba/v1/company/${companyId}/driver-list`}
            tableDataSourceUrl='ba/v1/company'
            cellsCustomComp={{
              startDate: <TableDateFormatter dataKey='startDate' />,
              firstName: (
                <TableUsernameFormatter
                  startKey='firstName'
                  endKey='lastName'
                />
              ),
              averageRating: (
                <TableStarRattingFormatter dataKey='averageRating' />
              ),
            }}
            moreOptionsComponents={[
              <ActionRow
                key='View driver performance'
                label='View driver performance'
                width='257px'
                icon={<MoreInfoIcon />}
                actionFn={async (data: any) => {
                  console.log('View driver performance', data);
                  navigate(
                    `/${DRIVER_INFORMATION}/${companyId}/${companyName}/${data.id}/performance/${encodeURIComponent(JSON.stringify(data))}`,
                  );
                }}
              />,
            ]}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverInformation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
